import type { Locale, RestaurantRecipe, RestaurantDepartment } from './types';

const normalize = (value: string) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();

/** Search only the recipes already authorized for this view; never changes their order. */
export function filterRecipeCatalog(recipes: RestaurantRecipe[], query: string, _locale: Locale, departments: RestaurantDepartment[]) {
  const terms = normalize(query).split(/\s+/).filter(Boolean);
  if (!terms.length) return recipes;
  return recipes.filter(recipe => {
    const department = departments.find(entry => entry.id === recipe.departmentId);
    const haystack = normalize([recipe.name.en, recipe.name.es, department?.name.en, department?.name.es,
      ...recipe.ingredients.flatMap(line => [line.itemName.en, line.itemName.es])].filter(Boolean).join(' '));
    return terms.every(term => haystack.includes(term));
  });
}
